import "./TabContent.css";
import "./TabContentResponsive.css";

import { TabType } from "../types/tabTypes";
import parseHtml from "html-react-parser"

type TabContentProps = {
  data: TabType;
};

function TabContent({ data }: TabContentProps) {
  return (
    <div className="tab-data-content">
      {data.sections.map(({ header, body }, index) => {
        return (
          <div className="tab-content-section" key={index}>
            {header && <h4>{header}</h4>}
            {body && <p>{parseHtml(body)}</p>}
          </div>
        );
      })}
    </div>
  );
}

export default TabContent;
